import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import MediaQuery from 'react-responsive'
import {navigate } from 'gatsby'
import DetailContainer from './detail'
import Dummy from 'components/dummy'
import CardStyles from './card.module.css'
import Style from './grid.module.css'
import Select from '../grid/select.js'

const asFilters = (filters, allowEmpty)=>{
  if(!allowEmpty){
    allowEmpty = true
  }
  let _res = {};
  for(let key in filters) {
    const val = filters[key];
    let items = []
    if(allowEmpty){
      items.push({
        value:"*",
        label: "All",
        isSelected: true
      })
    }
    if (val && val.length){
      items = items.concat(val.map(i => {
        return {
          value: i.id,
          label: i.name,
          isSelected: false
        }
      }))
    }
    _res[key]=items
  }
  return _res
}

export const withStoryGrid = (CardComponent, DetailComponent, collection, filters) => {
  return class extends Component {
    constructor(props){
      super(props)
      this.state = {
        per_row: 3,
        activeDetail: null,
        allItems: [...collection],
        filters: filters ? asFilters(filters) : undefined,
        activeFilters: {},
        activeItems: [...collection],
        containerWidth: null,
        cardWidth: null
      }
      this.rendererRefs = []
      this.closeDetail = this.closeDetail.bind(this)
      this.chunks = this.chunks.bind(this)
      this.containerRef = React.createRef();
      this.cardRef = React.createRef();
      this.renderDesktop = this.renderDesktop.bind(this);
      this.updateSizes = this.updateSizes.bind(this);
    }
    updateSizes(){

      const containerWidth = this.containerRef.current?this.containerRef.current.clientWidth:200
      const cardWidth = this.cardRef.current?this.cardRef.current.clientWidth:  0
      this.setState({
        containerWidth: containerWidth,
        cardWidth: cardWidth,
        per_row:  Math.max(1,Math.floor(containerWidth /(cardWidth+30)))
      })
    }
    updateFilter(selected, filter){
      let newState = {
        activeFilters:{...this.state.activeFilters}
      }
      if(selected){
        newState.activeFilters[filter]=selected
      }
      if(selected.value==="*"){
        newState.activeItems = this.state.allItems
      }else {
        newState.activeItems = this.state.allItems.filter(item => {
          if(item.hasOwnProperty(filter) && item[filter] && item[filter].length){
            if(item[filter].find(f=>f.id===selected.value)){
              return item
            }
          }
          return false;
        })
      }
      this.setState(newState)
    }


    componentDidMount(){
      this.updateSizes();
      window.addEventListener('resize', this.updateSizes)
    }
    componentWillUnmount(){
      window.removeEventListener('resize', this.updateSizes)
    }

    chunks(arr, size){
      if(arr && arr.length >0 ){
        const chunks= [].concat(
          Array.from(
            { length: Math.ceil(arr.length / size) },
            (v, i) => arr.slice(i * size, i * size + size)
          )
        )
        return [].concat(chunks)
      }
      return []
    }
    closeDetail(){
      if(this.state.activeDetail){
        const parent = this.rendererRefs[this.state.activeDetail]
        ReactDOM.unmountComponentAtNode(parent)
      }
    }
    renderDetail(target, item){
      this.closeDetail()
      const el = this.rendererRefs[target];
      ReactDOM.render(
        <DetailContainer
          onClose={this.closeDetail}
        >
          <DetailComponent
            {...item}
          />
        </DetailContainer>
        ,
        el,
        ()=>{this.setState({activeDetail:target})}
      )
    }
    renderDesktop (){
      return (
        <div>
          {this.chunks(filters ? this.state.activeItems : collection, this.state.per_row).map((chunk, index) => {
                const chunk_ref_key = `chunk${index}`
                return(
                  <div key={`storyrow-${index}`}>
                    <div className="flex justify-between">
                      {chunk.map( (item, index) => {
                        return(
                          <div
                            key={index}
                            onClick={()=>this.renderDetail(chunk_ref_key, item)}
                            className={CardStyles.card}

                          >
                            <CardComponent {...item} />
                          </div>)})}
                    </div>
                    <div
                      className="reader w-100"
                      ref={(ref)=>{
                        this.rendererRefs[chunk_ref_key]=ref;
                        return true}}
                    />
                  </div>
                )})}

         </div>
      )
    }
    render(){
      return(
        <>
        <div className="absolute" style={{visibility:'hidden'}}>
            <CardComponent
              {...this.state.allItems[0]}
              ref={this.cardRef}
            />
          </div>
          {this.state.filters && Object.keys(this.state.filters).length > 0 && 
           <div className={Style.filterContainer}>
             <div className={Style.filter}>
               {Object.keys(this.state.filters).map(
                 filter => <Select
                     choices={this.state.filters[filter]}
                     onChange={(selected)=>this.updateFilter(selected,filter)}/>
               )}
             </div>
           </div>
          }
          <div ref={this.containerRef}>
          
          <MediaQuery query="(min-width: 769px)">
            {this.renderDesktop(this.state.per_row)}
          </MediaQuery>

            <MediaQuery query="(max-width: 768px)">
            <div className="flex flex-col mx-auto items-center">
              {collection.length && collection.map((item,index) => (
                <div className='flex-shrink-0 mb-3 cursor-pointer'   key={index} onClick={()=> navigate(item.path)} >
                  <CardComponent
                    {...item}
                  />
                </div>
              ))}
            </div>
        </MediaQuery>
       </div>
        </>
      )
    }
  }
}
